module.exports = __webpack_public_path__ + "static/img/2areaB_40.3c4fb9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_40.png
// module id = 1157
// module chunks = 1